export var PRODUCT_EXTRA_ENRICHMENT_FIELDS = ['builderId', 'newbuildingId'];